var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-card',{staticClass:"account-card"},[_c('h2',{staticClass:"account-card__title",attrs:{"slot":"header"},slot:"header"},[_vm._v(" "+_vm._s(_vm.$t("account.set_phone_login_title", "Login by Phone"))+" ")]),_c('section',[_c('accountSetPhoneLogin',{attrs:{"defaultCountry":_vm.defaultCountry}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }